module.exports = __webpack_public_path__ + "73f6dd871bfb92689ea92ccec6c81137.pdf";